import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PasswordResetSuccessMessage = () => {
  const navigate = useNavigate();
  const [isResetSuccessful, setIsResetSuccessful] = useState(false);


  useEffect(() => {
    const resetStatus = sessionStorage.getItem('passwordResetStatus');

    if (resetStatus) {
      setIsResetSuccessful(resetStatus === 'success');
      sessionStorage.removeItem('passwordResetStatus');
    } else {
      const urlParams = new URLSearchParams(window.location.hash.slice(1));
      const state = urlParams.get('state');

      if (state) {
        try {
          const stateObject = JSON.parse(decodeURIComponent(state));
          if (stateObject.passwordResetSuccess) {
            setIsResetSuccessful(true);
            sessionStorage.setItem('passwordResetStatus', 'success');
          } else {
            setIsResetSuccessful(false);
          }
          window.location.hash = '';
        } catch (error) {
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    }

    const handleBeforeUnload = () => {
      window.history.replaceState(null, '', window.location.pathname);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    const handlePopState = () => {
      navigate('/login');
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);



  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(-20deg, #616161 0%, #9bc5c3 100%)',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 430,
          width: '100%',
        }}
      >
        {isResetSuccessful === true ? (
          <>
            <CheckCircleOutline
              sx={{
                fontSize: 64,
                color: green[500],
                mb: 2,
              }}
            />
            <Typography variant="h5" component="h1" gutterBottom>
              Password Updated!
            </Typography>
            <Typography variant="body1" align="center" color="text.secondary">
              Your password has been changed successfully.
              Use your new password to log in.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleLoginClick}
              sx={{ mt: 3 }}
            >
              Go to Login
            </Button>
          </>
        ) : isResetSuccessful === false ? (
          <>
            <ErrorOutline
              sx={{
                fontSize: 64,
                color: red[500],
                mb: 2,
              }}
            />
            <Typography variant="h5" component="h1" gutterBottom>
              Password Reset Failed
            </Typography>
            <Typography variant="body1" align="center" color="text.secondary">
              Something went wrong with the password reset. Please try again.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleLoginClick}
              sx={{ mt: 3 }}
            >
              Go to Login
            </Button>
          </>
        ) : (
          <Typography variant="body1" align="center" color="text.secondary">
            Loading...
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default PasswordResetSuccessMessage;
